export default {
      id: "user-usage",
      viewBox: "0 0 27 28",
      url: __webpack_public_path__ + "img/icons.svg#user",
      toString: function () {
        return this.url;
      }
    }